export default {
  state: {
    userLogin: {
      cpf: "",
      password: "",
    },

    userNoAuth: {},
    userPolyclinic: {},
  },

  getters: {
    getUserLogin(state) {
      return state.userLogin;
    },

    getUserNoAuth(state) {
      return state.userNoAuth;
    },

    getUserPolyclinic(state) {
      return state.userPolyclinic;
    },
  },

  mutations: {
    setUserLogin(state, user) {
      state.userLogin = user;
    },

    setUserNoAuth(state, user) {
      state.userNoAuth = user;
    },

    setUserPolyclinic(state, data) {
      state.userPolyclinic = data;
    },
  },

  actions: {
    changeUserLogin(context, user) {
      context.commit("setUserLogin", user);
    },

    changeUserNoAuth(context, user) {
      context.commit("setUserNoAuth", user);
    },

    changeUserPolyclinic(context, data) {
      context.commit("setUserPolyclinic", data);
    },
  },
};
